import React, {useEffect} from 'react';
import {Route, Routes,} from 'react-router-dom';
import {Home} from "../index";
import {cn, isMobileDevice} from "../../../utils/utils";
import {useBackground} from "./backgroundContext/backgroundContext";
import {useSelector} from "react-redux";
import users from "../../users";
import './body.css';
import auth from '../../../utils/authentication';
import {useChatStore} from '../../chatbot/store/chatbotStore';
import SquadflixTvMode from "../squadflix-tv-mode/squadflix-tv-mode";
import UnauthorizedHome from "../home/unauthorizedHome";
import {SquadDiskUsersApi} from "../../../apis/squaddisk-users/SquadDiskUsersApi";
import SocketUtils from "../squadflix-tv-mode/socket-utils/socketUtils";

const Body = () => {
    const {background} = useBackground();
    const darkMode = useSelector(users.selectors.isDarkMode);
    const {
        setPermissions
    } = useChatStore();

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(async (user) => {
            if (user) {
                SquadDiskUsersApi.getUserRights(user.uid).then((perms) => {
                    setPermissions(perms.data.permissions || {});
                }).catch((err) => {
                    console.error("Error fetching user permissions:", err);
                });
                
                // Connect to the main chatbot socket
                SocketUtils.connect({ uid: user.uid });
            } else {
                console.log("No user signed in");
                SocketUtils.disconnect();
            }
        });

        return () => {
            unsubscribe();
            SocketUtils.disconnect();
        };
    }, []);

    return (
        <div
            className={cn("app_body", !isMobileDevice() && "container")}
            style={{
                maxWidth: isMobileDevice() ? undefined : "100vw",
                width: isMobileDevice() ? "100vw" : undefined,
                height: "100vh",
                background: background,
                position: "fixed",
                overflow: "hidden",
                padding: 0,
            }}
        >
            {/* Overlay principal */}
            <div
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: darkMode
                        ? "rgba(33,37,41,0.55)"
                        : "rgba(255,255,255,0.5)",
                    pointerEvents: "none",
                    zIndex: 0,
                }}
            />

            {/* Sombra izquierda */}
            <div
                className="body__image-shadow"
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "400px",
                    height: "100%",
                    background: darkMode
                        ? "linear-gradient(to right, rgba(33,37,41,0.8), transparent)"
                        : "linear-gradient(to right, rgba(255,255,255,0.8), transparent)",
                    pointerEvents: "none",
                    zIndex: 1,
                }}
            />

            {/* Sombra derecha */}
            <div
                className="body__image-shadow"
                style={{
                    position: "absolute",
                    top: 0,
                    right: 0,
                    width: "400px",
                    height: "100%",
                    background: darkMode
                        ? "linear-gradient(to left, rgba(33,37,41,0.8), transparent)"
                        : "linear-gradient(to left, rgba(255,255,255,0.8), transparent)",
                    pointerEvents: "none",
                    zIndex: 1,
                }}
            />

            {/* Contenido */}
            <div style={{position: "relative", zIndex: 2}}>
                <Routes>
                    <Route path="/tv-mode" element={<SquadflixTvMode/>}/>
                    {auth.currentUser && <Route path="*" element={<Home/>}/>}
                    {!auth.currentUser && <Route path="*" element={<UnauthorizedHome/>}/>}
                </Routes>
            </div>
        </div>
    );
};

export default Body;
